/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const columns = [
  {
    field: 'PutawayOn',
    headerName: 'Putaway on',
    width: 200,
    type: 'Date',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'SKU',
    headerName: 'SKU',
    width: 250,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'PartNumber',
    headerName: 'Part Number',
    width: 280,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'Description',
    headerName: 'Part Description',
    width: 350,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'PutawayQty',
    headerName: 'Putaway Quantity',
    width: 200,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'OverpackQty',
    headerName: 'Overpack Quantity',
    width: 200,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },

];

const CorePutaway = () => {
  const strt = new Date(new Date(new Date().getTime()).setMonth(new Date().getMonth() - 1));
  const end = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(end);
  const [tableData, setTableData] = useState([]);
  const { activeMenu } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        InboundTable();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(end); // for compulsory dates
    }
  }, [startDate, endDate]);

  const InboundTable = async () => {
    setLoading(true);
    const myHeaders = {
      'Content-Type': 'application/json',
    };

    const requestData = {
      UserId:
        JSON.parse(localStorage.getItem('loginID'))?.UserId || null, // using optional chaining operator
      ProcessName: 'SimpliSafePortal',
      PageName: 'SimpliCertified Production',
      FromDate: startDate,
      ToDate: endDate,
    };

    await axios.post(`${variables.BASE_URL}CorePutaway`, requestData, {
      headers: myHeaders,
    })
      .then((response) => {
        const result = response.data;
        if (result?.IsSuccess !== false && result?.IsAuthorize !== false) {
          setTableData(result?.CorePutaway);
        } else if (result?.IsSuccess !== true && result?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData([]);
        } else if (result?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error:', error);
      });
  };
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full"
          id="navMenu_id"
        >
          <Navbar />
          <DateRangePicker
            loading={loading}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            disableFutureDates={disableFutureDates}
            TransferIntakeTable={InboundTable}
          />
        </div>
        <div>
          <div className="container-fluid">
            <div id="table_container">
              <Paper className="table_backpaper">
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <CustomDataGrid
                      name="Core Putaway"
                      tableData={tableData}
                      column={columns}
                    />
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorePutaway;
